export const widgetDefault = {
  background: '#ffffff',
  text: '#000000',
}
